import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AccountModule } from '@blade-sxp/account/store/account';
import { handleError } from '@blade/common/utils/handle-error';
import * as _ from 'lodash';
let default_1 = class default_1 extends Vue {
    input;
    maxlength;
    placeholder;
    toCheck;
    privacyMode;
    visible1 = false;
    innerInput = '';
    debounceFun;
    hiddenInput = '';
    confirmVisible = false;
    mounted() {
        this.debounceFun = _.debounce(this.onChange, 200);
        if (this.privacyMode !== 'true') {
            this.visible1 = true;
        }
        else {
            this.visible1 = false;
        }
    }
    handleVisible1() {
        const doubleAuth = localStorage.getItem('doubleAuth');
        if (doubleAuth !== 'true' && this.toCheck === 'EDIT') {
            this.$elprompt(this.$t('text2').toString(), 'Tip', {
                confirmButtonText: this.$t('ok').toString(),
                cancelButtonText: this.$t('cancel').toString(),
                inputType: 'password',
            }).then(async ({ value }) => {
                try {
                    await AccountModule.doubleCheck(value);
                    localStorage.setItem('doubleAuth', 'true');
                    this.visible1 = true;
                    return;
                }
                catch (e) {
                    handleError(e);
                }
            }).catch(() => {
            });
        }
        else {
            this.visible1 = !this.visible1;
        }
    }
    handleChange() {
        // console.log("input:", this.innerInput)
        const doubleAuth = localStorage.getItem('doubleAuth');
        if (doubleAuth === 'true' || this.toCheck === 'CREATE') {
            this.$emit('update:input', this.hiddenInput);
            return;
        }
        this.debounceFun();
    }
    onChange() {
        this.hiddenInput = this.input;
        if (this.confirmVisible) {
            return;
        }
        this.confirmVisible = true;
        this.$elprompt(this.$t('text1').toString(), 'Tip', {
            confirmButtonText: this.$t('ok').toString(),
            cancelButtonText: this.$t('cancel').toString(),
            inputType: 'password',
            beforeClose: (action, instance, done) => {
                this.confirmVisible = false;
                done();
            }
        }).then(async ({ value }) => {
            try {
                await AccountModule.doubleCheck(value);
                localStorage.setItem('doubleAuth', 'true');
                this.visible1 = true;
            }
            catch (e) {
                handleError(e);
            }
        }).catch(() => {
        });
    }
    inputHandler(e) {
        const preVal = this.innerInput;
        // insert cursor location
        const index = e.target.selectionStart;
        const nowVal = e.target.value;
        // increase length of input's value
        const incre = nowVal.length - preVal.length;
        // increase text
        if (incre >= 0) {
            const newStr = nowVal.slice(index - incre, index);
            this.innerInput = preVal.slice(0, index - incre) + newStr + preVal.slice(index - incre);
            console.log('e:', e);
            // delete text
        }
        else if (incre < 0) {
            this.innerInput = preVal.slice(0, index) + preVal.slice(index - incre);
        }
        // render mask effect
        if (nowVal.length > 0) {
            const len = nowVal.length - 4 > 0 ? nowVal.length - 4 : 0;
            //  this.hiddenInput = this.pointGen("*", nowVal.length - 1) + nowVal.charAt(nowVal.length - 1);
            e.target.value = this.pointGen('*', len) + nowVal.slice(len);
        }
        console.log('e:', this.innerInput);
        // reset insert cursor location
        e.target.setSelectionRange(index, index);
        // console.log(this.realText);
    }
    pointGen(pattern, num) {
        return new Array(num).fill(pattern).join('');
    }
    onInputChange(newVal) {
        // console.log("input:", newVal)
        if (!this.input) {
            return;
        }
        this.hiddenInput = newVal;
    }
};
__decorate([
    Prop({ type: String, default: '' })
], default_1.prototype, "input", void 0);
__decorate([
    Prop({ type: Number, default: 50 })
], default_1.prototype, "maxlength", void 0);
__decorate([
    Prop({ type: String, default: '' })
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop({ type: String, default: 'EDIT' })
], default_1.prototype, "toCheck", void 0);
__decorate([
    Prop({ type: String, default: false })
], default_1.prototype, "privacyMode", void 0);
__decorate([
    Watch('input')
], default_1.prototype, "onInputChange", null);
default_1 = __decorate([
    Component({
        name: 'portrait',
        i18n: {
            messages: {
                'en-us': {
                    text1: 'To change data, please enter login password',
                    text2: 'To view data, please enter login password',
                    ok: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    text1: '修改数据，请输入登录密码二次身份确认',
                    text2: '查看数据，请输入登录密码二次身份确认',
                    ok: '确认',
                    cancel: '取消'
                },
            },
        },
    })
], default_1);
export default default_1;
